/**
 * Client-side navigation without full page reload.
 */
export function navigate(to) {
  if (!to) return;
  if (to.startsWith("/")) {
    const current = window.location.pathname + window.location.search;
    if (current !== to) window.history.pushState({}, "", to);
  }
  window.dispatchEvent(new CustomEvent("app:navigate", { detail: { to } }));
}

export function pathToPage(pathWithQuery) {
  const path = (pathWithQuery || "/").split("?")[0];
  if (
    path.startsWith("/board") ||
    path.startsWith("/write") ||
    path.startsWith("/doctors") ||
    path.startsWith("/wall") ||
    path.startsWith("/rx/")
  ) {
    return path;
  }
  if (path === "/" || path === "") return "home";
  return path.replace(/^\//, "") || "home";
}
